import common from './common.json';
import widgets from './widgets.json';
import unprocessed from './unprocessed.json';

export default {
  ...common,
  ...widgets,
  ...unprocessed,
};
